const removeClass = className => el => el.classList.remove(className);

export default removeClass;



// WEBPACK FOOTER //
// ./app/scripts/util/DOM/removeClass.js